import React, { useState, useRef } from 'react';
import '../QuoteForm.css';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";
const QuoteForm = () => {
  const [uploadedImage, setUploadedImage] = useState(null);
  const recaptchaRef = useRef(null);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    // company: '',
    productType: '',
    decorationType: '',
    quantity: '',
    // dueDate: '',
    location: '',
    productStyle: '',
    additionalInfo: '',
    image: ''
  });
  const handleCaptchaChange = (value) => {
    setCaptchaValid(!!value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const generateQuoteFormTableHTML = (formData) => {
    return `
    <table style="border-collapse: collapse; width: 100%; font-size: 14px;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px;">Name</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Email</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Phone</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Product Type</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Decoration Type</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Quantity</th>

          <th style="border: 1px solid #ddd; padding: 8px;">Location</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Product Style</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Additional Info</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Uploaded Image</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.name}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.email}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.phone}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.productType}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.decorationType}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.quantity}</td>
         
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.location}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.productStyle}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${formData.additionalInfo}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">
            ${formData.image
        ? `<a href="${formData.image}" target="_blank">View Image</a>`
        : 'No Image'}
          </td>
        </tr>
      </tbody>
    </table>
  `;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Attach the uploaded image URL to formData.image before sending
    const formWithImage = {
      ...formData,
      image: uploadedImage, // Add this line to include the Cloudinary image URL
    };

    // console.log('Form Submitted:', formWithImage);

    const htmlTable = generateQuoteFormTableHTML(formWithImage);
    // console.log(htmlTable); // View HTML structure if needed

    const emailData2 = {
      from_name: 'Wear & Wonder Boutique',
      to_name: 'Payam',
      html_body: htmlTable,
    };

    emailjs
      .send('service_ra0tzqd', 'template_dcrf6kr', emailData2, 'K6B2QrefJnYCDCTa1')
      .then(response => {
        console.log('✅ Email sent successfully', response);
        // ✅ Clear form fields and uploaded image
        setFormData({
          name: '',
          email: '',
          phone: '',
          // company: '',
          productType: '',
          decorationType: '',
          quantity: '',
          // dueDate: '',
          location: '',
          productStyle: '',
          additionalInfo: '',
          image: '',
        });
        setUploadedImage(null);

        // Optional: Show confirmation message
        alert('Your quote request has been submitted!');
      })
      .catch(error => {
        console.error('❌ Error sending email:', error);
      });
  };

  const uploadImageToCloudinary = async (base64Image) => {
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dcuturlmb/image/upload', {
        method: 'POST',
        body: new URLSearchParams({
          file: base64Image,
          upload_preset: 'ml_default',
        }),
      });

      const data = await response.json();
      return data.secure_url;

    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };
  const submit = async (base64Image, chunkSize = 50000) => {
    const totalChunks = Math.ceil(base64Image.length / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
      const chunk = base64Image.slice(i * chunkSize, (i + 1) * chunkSize);

      const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/customerimage', {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chunk,
          chunkIndex: i,
          totalChunks
        }),
      });

      const result = await response.json();
      if (response.ok) {
        console.log('Image uploaded successfully:'
        );
      } else {
        console.error('Error uploading image:', result.message);
      }

    }

  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Image = reader.result; // This is a base64 string
        const result = await uploadImageToCloudinary(base64Image)
        setUploadedImage(result);
        setFormData(prev => ({ ...prev, image: result }));
        await submit(base64Image);
      };
      reader.readAsDataURL(file); // Read the image file as base64
    }



  };
  // Check required fields
  const isFormValid = [
    formData.name,
    formData.email,
    formData.phone,
    // formData.company,
    formData.productType,
    formData.decorationType,
    formData.quantity,
    // formData.dueDate,
    formData.location,
  ].every(field => field.trim() !== '');


  return (
    <div className="quote-form-container">
      <h2 className="quote-form-title">Request a Quote</h2>
      <form onSubmit={handleSubmit} className="quote-form">
        <div className="form-group">
          <input name="name" type="text" placeholder="Name" value={formData.name} onChange={handleChange} required />
          <input name="email" type="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <input name="phone" type="text" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
          {/* <input name="company" type="text" placeholder="Company" value={formData.company} onChange={handleChange} required /> */}
        </div>
        <div className="form-group">
          <select name="productType" value={formData.productType} onChange={handleChange} required>
            <option value="">Select Product Type</option>
            <option value="Shirts">Shirts</option>
            <option value="Promotional Products">Promotional Products</option>
            <option value="Outerwear">Outerwear</option>
            <option value="Headwear">Headwear</option>
            <option value="Other">Other</option>
          </select>
          <select name="decorationType" value={formData.decorationType} onChange={handleChange} required>
            <option value="">Select Decoration Type</option>
            <option value="Screen Printing">Screen Printing</option>
            <option value="Embroidery">Embroidery</option>
            <option value="Laser Etching / Engraving">Laser Etching</option>
            <option value="Emboss / Deboss">Emboss / Deboss</option>
            <option value="Heat Transfers">Heat Transfers</option>
            <option value="Patches">Patches</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group">
          <select name="quantity" value={formData.quantity} onChange={handleChange} required>
            <option value="">Select Quantity</option>
            <option value="48-99">48–99</option>
            <option value="100-299">100–299</option>
            <option value="300-599">300–599</option>
            <option value="600+">600+</option>
          </select>
          {/* <input name="dueDate" type="date" value={formData.dueDate} onChange={handleChange} required /> */}
        </div>

        <div className="form-group">
          <input name="location" type="text" placeholder="Decoration Location (e.g. Left Chest)" value={formData.location} onChange={handleChange} required />
        </div>

        <div className="form-group full">
          <label className="optional-label">
            Product Style Number (Optional)
            <input
              name="productStyle"
              type="text"
              placeholder="e.g. ST350"
              value={formData.productStyle}
              onChange={handleChange}
            />
            <small className="helper-text">Leave blank if unknown</small>
          </label>
        </div>

        <div className="form-group full">
          <textarea name="additionalInfo" placeholder="Additional Information" value={formData.additionalInfo} onChange={handleChange} rows="4" required />
        </div>
        <div className="form-group full">
          <div className="form-group">



            <input style={{ color: "navy" }} type="file" id="myFile" accept="png" onChange={handleFileChange} />
          </div>
          <div className="form-group2" style={{ width: 270 , maxWidth:400}}>
            <label style={{ color: "navy", fontSize: 13, marginTop: -15 }}>Choose your file (at this time for a better result .png format with no background only!)</label>

          </div>
          <div className="form-group">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY2}
              onChange={handleCaptchaChange}
              className="recaptcha-container"
            /> </div>
        </div>
        {isFormValid && captchaValid && (
          <div className="form-group full">
            <button type="submit" className="submit-btn">Submit</button>
          </div>
        )}
      </form>
    </div>
  );
};

export default QuoteForm;
